import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { getPartnersByBusinessRelationshipUuid, type PartnerDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function usePartnersByBrUuid(brUuid?: string, enabled = true): UseQueryResult<PartnerDto[], AxiosError> {
    return useQuery({
        queryKey: queryKeys.clientByBusinessRelationshipUuid(brUuid!),
        queryFn: ({ signal }) => getPartnersByBusinessRelationshipUuid({ path: { businessRelationshipUuid: brUuid! }, signal }).then((result) => result.data!),
        enabled: !!brUuid && enabled,
        retry: 1,
    });
}
